import { message } from 'antd'
import goLoginPage from './goLoginPage'

export const handler = err => {
  switch (err.name) {
    case 'NetworkClientError':
      if (err.status === 401) {
        goLoginPage()
      } else {
        message.error(err.message)
      }
      break
    default:
      message.error(err.message)
      break
  }
}

// window.addEventListener('unhandledrejection', event => {
//   handler(event.reason)
// })

// window.onerror = err => {
//   handler(err)
// }
